<template>
  <button
    class="tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer tw:underline"
    :class="{
      'tw:text-blue-600 tw:hover:text-blue-800': !warning,
      'tw:text-orange-600 tw:hover:text-orange-800': warning,
    }"
    data-testid="outreach-record-selected-section-link"
    type="button"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
interface Props {
  warning: boolean;
}
defineProps<Props>();
</script>
